// 메뉴 텍스트는 i18n(t)로 받고, 여기서는 라우트 정보만 정의합니다.
// 각 항목의 labelKey/translation key는 src/i18n/locales/{lang}.json 의 menu.* 참조.
export const MENU = [
  {
    labelKey: "menu.aboutUs",
    path: "/whoweare/",
    hashId: "whoweare",
    sub: [
      { labelKey: "menu.sub.whoweare", path: "/whoweare/", hashId: "whoweare" },
      { labelKey: "menu.sub.heringsteam", path: "/heringsteam/", hashId: "heringsteam" },
      { labelKey: "menu.sub.ir", path: "/irinformation/", hashId: "irinformation" },
    ],
  },
  {
    labelKey: "menu.ourService",
    path: "/rpmsolution/",
    hashId: "rpmsolution",
    sub: [
      { labelKey: "menu.sub.rpm", path: "/rpmsolution/", hashId: "rpmsolution" },
      { labelKey: "menu.sub.healthcare", path: "/healthcare/", hashId: "healthcare" },
      { labelKey: "menu.sub.clinicalresearch", path: "/clinicalresearch/", hashId: "clinicalresearch" },
    ],
  },
  {
    labelKey: "menu.news",
    path: "/news/",
    hashId: "news",
    sub: [{ labelKey: "menu.news", path: "/news/", hashId: "news" }],
  },
  {
    labelKey: "menu.contactUs",
    path: "/contactus/",
    hashId: "contactus",
    sub: [{ labelKey: "menu.contactUs", path: "/contactus/", hashId: "contactus" }],
  },
];
